import img1 from "./images/img1.jpg";
import img2 from "./images/img2.jpg";
import img3 from "./images/img3.jpg";
import img4 from "./images/img4.jpg";
import img5 from "./images/img5.jpg";
import img6 from "./images/img6.jpg";
import person1 from "./images/person1.jpg";
import person2 from "./images/person2.jpg";


export const properties=[
    { id: 1, title: '3140 Cherry Street Mobile, AL', image: img2, option: 'rent' }, 
    { id: 2, title: '3140 Cherry Street Mobile, AL', image: img1, option: 'buy' }, 
    { id: 3, title: '3140 Cherry Street Mobile, AL', image: img3, option: 'buy' }, 
    { id: 4, title: '3140 Cherry Street Mobile, AL', image: img4, option: 'rent' }, 
    { id: 5, title: '3140 Cherry Street Mobile, AL', image: img5, option: 'rent' }, 
    { id: 6, title: '3140 Cherry Street Mobile, AL', image: img6, option: 'buy' } 
];
export const features=[
    { id: 1, title: 'Wide Range of Properties', icon: 'fa-solid fa-sign-hanging' },
    { id: 2, title: '15+ Agents Available', icon: 'fa-solid fa-address-card' },
    { id: 3, title: 'Best Deals Guaranteed', icon: 'fa-solid fa-tags' },
];
export const steps=[
    { id: 1, title: 'Drop us mail', text: 'Lorem ipsum dolor sit ametconsetetur sadipscing nonumy eirmod', icon: 'fa-solid fa-envelope' },
    { id: 2, title: 'Select your location', text: 'Lorem ipsum dolor sit ametconsetetur sadipscing nonumy eirmod', icon: 'fa-solid fa-location-dot' },
    { id: 3, title: 'Rent or Buy', text: 'Lorem ipsum dolor sit ametconsetetur sadipscing nonumy eirmod', icon: 'fa-solid fa-house' },
];
export const testimonials=[
    { id:1, name: 'Rhea McLaughlin', profession: 'Creative Director', text: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.', image: person1},
    { id:2, name: 'Isabella Dolor', profession: 'Architect', text: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.', image: person2}
];
export const socialLinks=[
    { id:1, href:'https://www.facebook.com/',  icon:'fa-brands fa-facebook'},
    { id:2, href:'https://www.twitter.com/',  icon:'fa-brands fa-twitter'},
    { id:3, href:'https://www.youtube.com/',  icon:'fa-brands fa-youtube'},
    { id:4, href:'https://www.instagram.com/',  icon:'fa-brands fa-instagram'}
];